import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextCard from 'components/molecules/Cards/ContextCard/ContextCard';

const StyledUserContextCard = styled(ContextCard)`
  .UserContextCard {
    &-edit {
      display: none;
      margin-left: ${props => props.theme.layout('0.5sp')};
      color: ${props => props.theme.property('palette.text.disabled')};
    }
    
    &-content {
      display: flex;
      align-items: center;
      
      > *:first-child {
        flex-grow: 1;
      }
    }
    
    &-subject {
      display: flex;
      align-items: center;
      column-gap: ${props => props.theme.layout('1sp')};
    }
  }
  
  &.UserContextCard-canUpdate {
    .UserContextCard {
      &-content {
        cursor: pointer;

        &:hover {
          .UserContextCard {
            &-edit {
              display: block;
            }
          }
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledUserContextCard.propTypes = {
  theme: PropTypes.object
};

export default StyledUserContextCard;
